// extracted by mini-css-extract-plugin
module.exports = {"root":"SensitiveAttribute_root__I8j0D","attribute":"SensitiveAttribute_attribute__NsJPF"};